<template>
  <div>
    <div class="wrapper">
      <div class="banner" :class="{'banner-slide-in':show}">
        <font-awesome-icon icon="times" class="btn-close" @click="close"/>
        <font-awesome-icon icon="plus-square" class="icon"/>Install Guesstimate on your iPhone: tap
        <img
          class="share-icon"
          src="../assets/share-icon-iphone-20.jpg"
        >
        and then Add to HomeScreen
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddToHomeScreenIOSBanner',
  data() {
    return {
      show: false,
    };
  },
  methods: {
    close() {
      this.show = false;
    },
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 2000);
  },
};
</script>


<style scoped>
* {
  box-sizing: border-box;
  transition: all 1s;
}

.btn-close {
  /* padding: 0;
  height: 15px;
  width: 15px;
  margin: 0;
  right: 0;
  position: absolute;
  display: block; */
  float: right;
  color: purple;
}

.wrapper {
}

.banner {
  padding: 10px;
  margin-top: 20px;
  width: 100%;
  background: white;
  color: black;
  position: fixed;
  bottom: -100px;
}

.banner-slide-in {
  bottom: 0;
}

.icon {
  height: 20px;
  width: 18px;
  color: gray;
}

.share-icon {
  height: 25px;
}
</style>
